var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-photo-btn-component" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$t("FEED.ATTACH_IMAGE"),
            expression: "$t('FEED.ATTACH_IMAGE')"
          }
        ],
        staticClass: "btn__reset",
        on: { click: _vm.attachPhoto }
      },
      [
        _c("input", {
          ref: "file",
          staticClass: "hide",
          attrs: { type: "file", accept: "image/*", multiple: "" },
          on: { change: _vm.handleAttachPhoto }
        }),
        _vm._v(" "),
        _c("i", { staticClass: "icon-photo" })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }